module.exports = __webpack_public_path__ + "assets/TB_DB_Icon_SOURCE.svg";